import { z as e } from "./vendor-DWc995QB.mjs";
function a(o) {
  const n = e.union([...o, s]);
  return e.preprocess((t, r) => n.safeParse(t).success ? t : { __typename: "UNKNOWN" }, n);
}
const s = e.object({ __typename: e.literal("UNKNOWN") });
export {
  a as f
};
//# sourceMappingURL=flexibleUnion-CDkM8s3k.mjs.map
